import requestData from "../../../http/request";

/**
 * 获取聊天好友列表 Ajax
 * @return {*}
 */
/*export const getList = function (token, maxId) {
    let params = new URLSearchParams();
    params.append('ust', token);
    if (maxId&&maxId!=='null') {
        params.append('maxid', maxId)
    }
    return requestData('/chat/list', 'post', params)
}*/
/**
 * 获取历史记录 Ajax
 * @param token         传入token
 * @param receiverId    传入好友对方的id
 * @param page          传入page
 * @param minId         传入请求数据里最小的参数命为id的参数
 * @return {*}
 */
/*export const getDetail = function (token, receiverId, page, minId) {
    let params = new URLSearchParams();
    params.append('ust', token);
    params.append('receiverId', receiverId);
    params.append('page', page)
    params.append('minid', minId)
    return requestData('/chat/detail', 'post', params)

}*/

/**
 * 上传图片资源
 * @param messageImage
 * @param token
 * @returns {Promise}
 */
export const upload =  function (messageImage,token) {
    let file = new FormData();
    file.append('ust',token);
    file.append('file',messageImage);
    /*聊天截图使用screenShot*/
    if(typeof messageImage==='string'){
        file.append('uploadType','screenShot');
        return new Promise(resolve => requestData('/public/upload', 'post', file).then(res => resolve(res.data)))
    }
    if(!messageImage||!messageImage.name)return new Promise(resolve => resolve('传入的数据错误，请传文件对象(e表示回调函数的第一个参数) e.dataTransfer.files[0]'));
    if(/.(jpg|png|gif)$/.test(messageImage.name)){
        file.append('uploadType', 'chatImg')
        return new Promise(resolve => requestData('/public/upload', 'post', file).then(res => resolve(res.data)))
    }

    /* mp3,wav 媒体目前只能这两个  */
    if(/.(mp3|wav)$/.test(messageImage.name)){
        file.append('uploadType','chatMedia');
        return new Promise(resolve => requestData('/public/upload', 'post', file).then(res => resolve(res.data)));
    }

    //['zip', 'rar', 'doc','docx','xls','xlsx','txt','pdf']
    if(/.(zip|rar|doc|docx|xls|xlsx|txt|pdf)$/.test(messageImage.name)){
        file.append('uploadType','chatFile');
        return new Promise(resolve => requestData('/public/upload', 'post', file).then(res => resolve(res.data)));
    }

    return new Promise(resolve => resolve('系统无法识别传输的内容是什么类型，无法上传'))

}
/**
 * 发送消息
 * @param token         验证登录状态的令牌限制
 * @param receiverId    接收人
 * @param message       发送消息的内容
 * @param messageType   消息类型 0是普通文字，1是图片
 * @return {*}
 */
/*export const sendAMessage = function (token, receiverId, message, messageType) {
    switch (messageType) {
        case 0:
            let textParams = new URLSearchParams();
            textParams.append('ust', token);
            textParams.append('receiverId', receiverId);
            textParams.append('mesg', message);
            textParams.append('msgType', messageType);
            return requestData('/chat/chatadd', 'post', textParams);
        case 1:
            return new Promise(resolve => {
                let file = new FormData();
                file.append('file', message);
                file.append('imgType', 'union');
                requestData('/public/upload', 'post', file).then(res => {
                    if (res.data.code == 1) {
                        return res.data.data
                    }
                }).then(res => {
                    let textParams = new URLSearchParams();
                    textParams.append('ust', token);
                    textParams.append('receiverId', receiverId);
                    textParams.append('mesg', res);
                    textParams.append('msgType', messageType);
                    requestData('/chat/chatadd', 'post', textParams).then(resSendMessage => {
                        resSendMessage['data']['data'] = res;
                        resolve(resSendMessage)
                    });
                })
            })
    }
}*/
/**
 * 获取聊天token
 * @param token 传入用户的token
 * @return {*}
 */
export const getChatTokenRequest = async function (token) {
    console.log(token);
    let params = new URLSearchParams();
    params.append('ust', token);
    let chatTokenStorage={};
    console.log(this.Common);
    let chatToken  = await requestData('/chat/gettoken', 'POST', params);
    if(parseInt(chatToken.data.code)===0){
        this.Common.setChatToken({chatToken:chatToken.data.data})
        // storage.set('chatToken',chatToken.data.data);
        return;
    }
 /*   if(!this.Common.chatToken){
        let chatToken  = await requestData('/chat/gettoken', 'POST', params);
        if(parseInt(chatToken.data.code)===0){
            this.Common.setChatToken({chatToken:chatToken.data.data})
            // storage.set('chatToken',chatToken.data.data);
            return;
        }
    }

    if(this.Common.chatToken&&this.Common.chatToken==='null'&&this.Common.chatToken==='undefined'){
        let chatToken  = await requestData('/chat/gettoken', 'POST', params);
        if(parseInt(chatToken.data.code)===0){
            // storage.set('chatToken',chatToken.data.data);
            this.Common.setChatToken({chatToken:chatToken.data.data})
            return;
        }
    }
    if(!this.Common.chatToken)return;
    if(this.Common.chatToken.expire<parseInt(new Date().getTime()/1000)){
        let chatToken  = await requestData('/chat/gettoken', 'POST', params);
        if(parseInt(chatToken.data.code)===0){
            // storage.set('chatToken',chatToken.data.data);
            this.Common.setChatToken({chatToken:chatToken.data.data})
            return;
        }
    }*/
    chatTokenStorage=this.Common.chatToken;
    return chatTokenStorage
}
/**
 * 获取公司信息
 * @param token
 * @param roomIdArr
 */
export const getCompanyInfo=(token,roomIdArr)=>{
    let params = new URLSearchParams();
    params.append('ust', token)
    if(typeof roomIdArr=='object') roomIdArr = JSON.stringify(roomIdArr);
    params.append('roomIdArr', roomIdArr);
    return requestData('/chat/getAllCompanyInfo', 'post', params)
}
/**
 * 发送消息微信推送
 * @param token 参数名ust
 * @param roomId 无需在视图层处理
 */
export const sendWeChat=(token,roomId)=>{
    /*
    后面可能添加参数携带聊天的信息
    超过10个...
        小于全反
        参数名message
        message[图片]
        音频
        视频
        文件

    * */
    const params = new URLSearchParams();
    params.append('ust',token);
    params.append('roomId',roomId.indexOf(location.hostname)>-1?roomId.match(/_.*/)[0].replace('_',''):roomId);
    return requestData('/chat/wechatNotice','post',params)
}

/**
 * 搜索框请求
 * @param token
 * @param page 页码
 * @param pageSize 每页返回的条数
 * @param keyword 搜索的关键词
 */
export const searchChatCompany=(token,page,pageSize,keyword)=>{
    if(!keyword.trim()){return new Promise(resolve => resolve({code:1,data:[]}))}
    else{
        let params = new URLSearchParams();
        params.append('ust',token);
        params.append('page',page);
        params.append('pageSize',100);
        params.append('keyword',keyword);
        params.append('type','chat');
        return requestData('/company/index','POST',params)
    }
}

/**
 * 获取聊天房间内的getAllCompanyInfo没有的用户ID的数据
 * @param token
 * @param userId    用户的Id
 * @returns {*}
 */
export const getNewUserInfo = (token,userId)=>{
    if(!String(token)||!String(userId)) return Promise.reject('登录身份或者用户身份识别错误');
    let params = new URLSearchParams();
    params.append('ust',token);
    params.append('uid',userId);
    return requestData('/user/userEdit','POST',params);
}

/**
 * 查找货源
 * @param authKey
 * @param SearchText
 */
export const getDealers = ({authKey, searchText}) => {
  if(!authKey || !searchText) return Promise.reject('登录身份或识别内容为空');
  let params = new URLSearchParams();
  params.append('ust', authKey);
  params.append('OEcode', searchText);
  return new Promise( (resolve,reject) => {
    requestData('/exdata/getDealers','POST',params).then(res=>{
      const resolveData ={
        dealersList:[]
      };
      resolveData.dealersList = res.data.rows.map(item=>{return{
        address: item.address,
        alias: item.alias,
        area: item.area,
        biz_province: item.biz_province,
        brand: item.brand,
        car_desc: item.car_desc,
        company_name: item.company_name,
        contact: item.contact,
        cost_price: item.cost_price,
        keywords: item.keywords,
        mobile: item.mobile,
        oe_code: item.oe_code,
        origin: item.origin,
        packing_list: item.packing_list,
        qq: item.qq,
        quality: item.quality,
        quote_price: item.quote_price,
        share_price: item.share_price,
        spell: item.spell,
        supplier_code: item.supplier_code,
        tel: item.tel,
        union_id: item.union_id,
        update_time: item.update_time,
        virtual_stock: item.virtual_stock,
        ware_code: item.ware_code,
        ware_id: item.ware_id,
        ware_img: item.ware_img,
        ware_model: item.ware_model,
        ware_name: item.ware_name,
        ware_unit: item.ware_unit,
        zero_price: item.zero_price,
        supplier_id: item.supplier_id,
        stock_update: item.stock_update,
        status: item.status,
        sign_guarantee: item.sign_guarantee,
        shop_show: item.shop_show,
        shelf: item.shelf,
        share_id: item.share_id,
        search_factor: item.search_factor,
        return_work: item.return_work,
        brand_id: item.brand_id,
        quote_id: item.quote_id,
        province: item.province,
        min_num: item.min_num,
        member_id: item.member_id,
        is_top: item.is_top,
        is_special: item.is_special,
        id: item.id,
        county: item.county,
        city: item.city,
        index_name: item.index_name,
        off_buy: item.off_buy,
        is_online: item.is_online,
        mobile_online: item.mobile_online,
        tax_include: item.tax_include,
        company_type: item.company_type,
        big_business: item.big_business,
        shop_url: item.shop_url,
        is_hot: item.is_hot,
      }})
      resolve(resolveData);
    }).catch(reason => {
      alert('网络传输错误！');
      console.trace('Middle error getDealers'+JSON.stringify(reason));
      reject(reason);
    })
  })
}
